const config = process.env.REACT_APP_FB_ENV === "prod"
  ? require('./FirebaseConstants-prod').default
  : require('./FirebaseConstants-dev').default;

export default config;
